<div style="display: flex; flex-direction: column">
    <div style="flex-basis: 50%">
        <app-lazada-orders></app-lazada-orders>
    </div>
    <div style="flex-basis: 50%">
        <app-shopee-orders title="Shopee (gen4)"></app-shopee-orders>
    </div>
    <div style="flex-basis: 50%">
        <app-shopee-genlogic-orders-wrapper></app-shopee-genlogic-orders-wrapper>
    </div>
</div>
